
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_49092","data-name":"Group 49092","transform":"translate(-1399.5 -113.99)"}},[_c('circle',{attrs:{"id":"Ellipse_11","data-name":"Ellipse 11","cx":"6","cy":"6","r":"6","transform":"translate(1399.5 113.99)","fill":"rgba(229,232,239,0.46)"}}),_c('path',{attrs:{"id":"Path_29277","data-name":"Path 29277","d":"M1403.94 117.26a2.017 2.017 0 012.585 0 1.462 1.462 0 010 2.262 1.8 1.8 0 01-.408.269 1.364 1.364 0 00-.884 1.113v.457m0 1.828h0z","fill":"none","stroke":"#8f8f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2"}})])])
          )
        }
      }
    